import { UniDriver } from '@wix/unidriver-core';
import {
  baseUniDriverFactory,
  findByHook,
} from '../../../utils/test-utils/unidriver';
import { iconButtonDriverFactory } from '../../../IconButton/IconButton.uni.driver';
import { dataHooks } from './constants';

export const headerUniDriverFactory = (base: UniDriver) => {
  const titleElement = () => findByHook(base, dataHooks.title);
  const subtitleElement = () => findByHook(base, dataHooks.subtitle);
  const breadcrumbsElement = () => findByHook(base, dataHooks.breadcrumbs);
  const actionBarElement = () => findByHook(base, dataHooks.actionBar);
  const backButtonElement = () => findByHook(base, dataHooks.backButton);

  return {
    ...baseUniDriverFactory(base),
    /**
     * Checks whether the PageHeader class exists
     * @param {name} className
     * @returns {Promise<boolean>}
     */
    hasClass: (className: string) => base.hasClass(className),
    /**
     * Gets PageHeader title text
     * @return {Promise<string>}
     */
    titleText: (): Promise<string> => titleElement().text(),
    /**
     * Checks whether the PageHeader title exists
     * @returns {Promise<boolean>}
     */
    isTitleExists: (): Promise<boolean> => titleElement().exists(),
    /**
     * Gets PageHeader subtitle text
     * @return {Promise<string>}
     */
    subtitleText: (): Promise<string> => subtitleElement().text(),
    /**
     * Checks whether the PageHeader subtitle exists
     * @returns {Promise<boolean>}
     */
    isSubtitleExists: (): Promise<boolean> => subtitleElement().exists(),
    /**
     * Checks whether the PageHeader breadcrumbs exists
     * @returns {Promise<boolean>}
     */
    isBreadcrumbsExists: (): Promise<boolean> => breadcrumbsElement().exists(),
    /**
     * Gets PageHeader breadcrumbs text
     * @return {Promise<string>}
     */
    breadcrumbsText: (): Promise<string> => breadcrumbsElement().text(),
    /**
     * Checks whether the PageHeader action bar exists
     * @returns {Promise<boolean>}
     */
    isActionBarExists: () => actionBarElement().exists(),
    /**
     * Checks whether the PageHeader back button exists
     * @returns {Promise<boolean>}
     */
    isBackButtonExists: (): Promise<boolean> => backButtonElement().exists(),
    /**
     * Clicks PageHeader back button
     * @returns {Promise<void>}
     */
    clickBackButton: (): Promise<void> =>
      iconButtonDriverFactory(backButtonElement()).click(),
  };
};

export type HeaderUniDriver = ReturnType<typeof headerUniDriverFactory>;
